import { Component } from '@angular/core';
import { UtilsTabsComponent } from '../../components/utils-tabs/utils-tabs.component';

@Component({
  selector: 'app-order-order-exception-table',
  standalone: true,
  templateUrl: './order-exceptions.component.html',
  imports: [UtilsTabsComponent],
  styleUrl: './order-exceptions.component.scss'
})
export class OrderExceptionsComponent {}
